import { HULL_BASES, type HullBase } from "./hull-bases.js";
import {
  HULL_MODELS,
  HULL_MODEL_IDS,
  type HullFamily,
  type HullModelId,
} from "./hull-models.js";

export const HULL_IDS = HULL_MODEL_IDS;
export type HullId = HullModelId;
export interface HullDefinition extends Omit<HullBase, "id"> {
  id: HullId;
  family: HullFamily;
  tier: 1 | 2 | 3;
  equipmentSlots: number;
  componentPrice: number;
  weaponBudget: number;
}
function ship(id: HullId): HullDefinition {
  const model = HULL_MODELS[id],
    base = HULL_BASES[model.family];
  const durability = model.tier === 1 ? 1 : model.tier === 2 ? 1.12 : 1.2;
  const cargo = model.tier === 1 ? 1 : model.tier === 2 ? 1.25 : 1.5;
  return {
    ...base,
    id,
    name: model.name,
    family: model.family,
    tier: model.tier,
    equipmentSlots: model.equipmentSlots,
    price: model.credits,
    componentPrice: model.components,
    hp: Math.round(base.hp * durability * 100) / 100,
    shield: 0,
    capacity: Math.min(64, Math.round(base.capacity * cargo)),
    radius:
      base.radius * (model.tier === 1 ? 1 : model.tier === 2 ? 1.15 : 1.3),
    weaponBudget: model.tier === 1 ? 1 : model.tier === 2 ? 1.15 : 1.35,
  };
}
export const HULLS: Record<HullId, HullDefinition> = {
  assault: ship("assault"),
  interceptor: ship("interceptor"),
  engineer: ship("engineer"),
  scout: ship("scout"),
  transport: ship("transport"),
  bastion: ship("bastion"),
  hawk: ship("hawk"),
  aerie: ship("aerie"),
  arrow: ship("arrow"),
  argosy: ship("argosy"),
  leviathan: ship("leviathan"),
  quicksilver: ship("quicksilver"),
  falcon: ship("falcon"),
  clipper: ship("clipper"),
  behemoth: ship("behemoth"),
};
